import MenuConst from "../MenuConst";

export class CompanyMenu extends MenuConst {
    static readonly NONE                 = MenuConst.NONE;
    static readonly RANGE_AREA           = MenuConst.MAIN;
    static readonly BASIC_DATA           = MenuConst.MAIN + 1;
    static readonly SERVICES             = MenuConst.MAIN + 2;
    static readonly ABOUT_COMPANY        = MenuConst.MAIN + 3;
    static readonly INFORMATION          = MenuConst.MAIN + 4;
    static readonly OPERATIONAL_CONTACTS = MenuConst.MAIN + 5;
    static readonly HELP                 = MenuConst.MAIN + 6;

    static arr = (():string[] => {
        let arr = [];

        arr[CompanyMenu.RANGE_AREA]           = 'Zasięgi';
        arr[CompanyMenu.BASIC_DATA]           = 'Podstawowe dane';
        arr[CompanyMenu.SERVICES]             = 'Usługi';
        arr[CompanyMenu.ABOUT_COMPANY]        = 'O firmie';
        arr[CompanyMenu.OPERATIONAL_CONTACTS] = 'Kontakty operacyjne';
        arr[CompanyMenu.INFORMATION]          = 'Informacje';

        return arr;
    })();

    static admin = (():boolean[] => {
        let admin = [];

        admin[CompanyMenu.NONE]                 = true;
        admin[CompanyMenu.RANGE_AREA]           = true;
        admin[CompanyMenu.BASIC_DATA]           = true;
        admin[CompanyMenu.SERVICES]             = true;
        admin[CompanyMenu.ABOUT_COMPANY]        = true;
        admin[CompanyMenu.INFORMATION]          = true;
        admin[CompanyMenu.OPERATIONAL_CONTACTS] = true;
        admin[CompanyMenu.HELP]                 = true;

        return admin;
    })();

    static items = (() => {
        return CompanyMenu.arr
            .map((value, index) => ({
                id: index,
                value: value
            }))
            .filter(item => item.value !== undefined);
    })();
}
